module.exports = __webpack_public_path__ + "img/金属材料学3_6_4.12885fcd.png";